import { IVatClient } from "../types/vatClient.type";
import { IVatTransaction } from "../types/vatTransaction.type";
import { IVatReport } from "../types/vatReport.type";
import { api } from "./api";


// VatClient API
export const vatClientApi = {
  create: (data: Partial<IVatClient>) =>
    api.post(`/vat-client`, data),

  getAll: (params?: any) =>
    api.get(`/vat-client`, { params }),

  getById: (id: string) =>
    api.get(`/vat-client/${id}`),

  update: (id: string, data: Partial<IVatClient>) =>
    api.put(`/vat-client/${id}`, data),

  delete: (id: string) =>
    api.delete(`/vat-client/${id}`),

  getBalance: () =>
    api.get(`/vat-client/balance`),
};

// VatTransaction API
export const vatTransactionApi = {
  create: (data: Partial<IVatTransaction>) =>
    api.post(`/vat-transaction`, data),

  getAll: (params?: any) =>
    api.get(`/vat-transaction`, { params }),

  getById: (id: string) =>
    api.get(`/vat-transaction/${id}`),

  update: (id: string, data: Partial<IVatTransaction>) =>
    api.put(`/vat-transaction/${id}`, data),

  delete: (id: string) =>
    api.delete(`/vat-transaction/${id}`),

  markAsPaid: (id: string, data: { paidAmount: { USD: number; UZS: number }; paymentDate: string }) =>
    api.patch(`/vat-transaction/${id}/paid`, data),

  getStats: (params?: any) =>
    api.get(`/vat-transaction/stats`, { params }),
};

// VatReport API
export const vatReportApi = {
  create: (data: Partial<IVatReport>) =>
    api.post(`/vat-report`, data),

  getAll: (params?: any) =>
    api.get(`/vat-report`, { params }),

  getById: (id: string) =>
    api.get(`/vat-report/${id}`),

  update: (id: string, data: Partial<IVatReport>) =>
    api.put(`/vat-report/${id}`, data),

  delete: (id: string) =>
    api.delete(`/vat-report/${id}`),

  submit: (id: string) =>
    api.patch(`/vat-report/${id}/submit`),
}; 